import { render, staticRenderFns } from "./template-choser.vue?vue&type=template&id=7b0b1227&lang=true&"
import script from "./template-choser.vue?vue&type=script&lang=js&"
export * from "./template-choser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports